import { spriteFromMap } from "./pixelArt";

export const PROFILE_ROLES = [
  { id: "indie", label: "Indie" },
  { id: "student", label: "Estudiante" },
  { id: "hobby", label: "Hobby" },
  { id: "studio", label: "Estudio pequeño" },
  { id: "teacher", label: "Docente" },
];

export const PROFILE_ACCENTS = [
  { id: "#0ea5e9", label: "Cielo" },
  { id: "#22c55e", label: "Bosque" },
  { id: "#eab308", label: "Oro" },
  { id: "#f97316", label: "Fuego" },
  { id: "#a78bfa", label: "Magia" },
  { id: "#fb7185", label: "Rosa" },
];

const FACE = {
  hero: [
    "................",
    "....hhhhhh......",
    "...hhhhhhhh.....",
    "...hhsssshh.....",
    "...hseosseh.....",
    "...hssSsssh.....",
    "....hssssh......",
    "....bbBBbb......",
    "...bbbbbbbb.....",
    "...bb....bb.....",
    "..llll..llll....",
    "..nnnn..nnnn....",
    "................",
    "................",
    "................",
    "................",
  ],
  mage: [
    "......llll......",
    ".....llllll.....",
    "....llllllll....",
    "...llhhhhhhll...",
    "...lhssssshl....",
    "...lseossel.....",
    "....lssssl......",
    "....llllll......",
    "...llmmmmll.....",
    "...ll....ll.....",
    "..mmmm..mmmm....",
    "..nnnn..nnnn....",
    "................",
    "................",
    "................",
    "................",
  ],
  slime: [
    "................",
    "................",
    ".....GGGGGG.....",
    "....GGGGGGGG....",
    "...GGeeGGeeG....",
    "...GGssGGssG....",
    "...GGGGDDGGG....",
    "....GGDDDGG.....",
    ".....GGGGGG.....",
    "................",
    "................",
    "................",
    "................",
    "................",
    "................",
    "................",
  ],
  knight: [
    "................",
    "....WWWWWW......",
    "...WWuuuuWW.....",
    "...WuooooWu.....",
    "...WuoeeouW.....",
    "...WWssssWW.....",
    "....WssssW......",
    "....ffffff......",
    "...ffffffffff...",
    "...ff....ff.....",
    "..ffff..ffff....",
    "..nnnn..nnnn....",
    "................",
    "................",
    "................",
    "................",
  ],
  fox: [
    "................",
    "...t....t.......",
    "..tttttttt......",
    "..ttsssstt......",
    "..tseosset......",
    "...tssSsst......",
    "....tssst.......",
    "....tttttt......",
    "...tttttttt.....",
    "...tt....tt.....",
    "..tttt..tttt....",
    "..nnnn..nnnn....",
    "................",
    "................",
    "................",
    "................",
  ],
  ghost: [
    "................",
    ".....pppppp.....",
    "....pppppppp....",
    "...ppuoooupp....",
    "...puoeoeoup....",
    "...ppuuuuupp....",
    "...ppppppppp....",
    "...pp.pp.ppp....",
    "...p..p..pp.....",
    "................",
    "................",
    "................",
    "................",
    "................",
    "................",
    "................",
  ],
};

export const AVATAR_PRESETS = [
  { id: "hero", label: "Héroe" },
  { id: "mage", label: "Mago" },
  { id: "knight", label: "Caballero" },
  { id: "fox", label: "Zorro" },
  { id: "slime", label: "Slime" },
  { id: "ghost", label: "Fantasma" },
];

const cache = {};

export function presetAvatarUrl(id) {
  if (!id || !FACE[id]) return "";
  if (!cache[id]) cache[id] = spriteFromMap(FACE[id], { scale: 4 });
  return cache[id];
}

export function roleLabel(id) {
  return PROFILE_ROLES.find((r) => r.id === id)?.label || "";
}

export function firstName(user) {
  const n = (user?.name || "").trim();
  if (!n) return "creador";
  return n.split(/\s+/)[0];
}

export function displayHandle(user) {
  if (user?.handle) return `@${user.handle}`;
  const fromName = (user?.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "").slice(0, 16);
  return fromName ? `@${fromName}` : "";
}

export function greetingLine(user, lang = "es") {
  const h = new Date().getHours();
  const name = firstName(user);
  if (lang !== "es") {
    const hi = h < 12 ? "Good morning" : h < 19 ? "Good afternoon" : "Good evening";
    return `${hi}, ${name}`;
  }
  const hi = h < 12 ? "Buenos días" : h < 19 ? "Buenas tardes" : "Buenas noches";
  return `${hi}, ${name}`;
}

export function sanitizeHandle(raw) {
  return String(raw || "")
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, "")
    .slice(0, 20);
}

export function resizeAvatarFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("No se pudo leer el archivo"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Imagen inválida"));
      img.onload = () => {
        const size = 96;
        const c = document.createElement("canvas");
        c.width = size;
        c.height = size;
        const ctx = c.getContext("2d");
        ctx.imageSmoothingEnabled = true;
        const s = Math.max(size / img.width, size / img.height);
        const w = img.width * s;
        const h = img.height * s;
        ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
        resolve(c.toDataURL("image/jpeg", 0.85));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
